export default {
  A: "#00639a",
  V: "#00639a",
  L: "#00639a",
  I: "#00639a",
  P: "#00639a",
};
